import { haveAnyValue } from 'src/utils/utilitiesV2'

export const getItemSellPrice = (item: ILineItem, defaultPrice: number): number => {
  return haveAnyValue(item.priceInSale) ? item.priceInSale : defaultPrice
}

export const formatItemToOperations = (
  items: IOrderDetailRequest[],
): IItemTaxOperation[] => {
  const response: IItemTaxOperation[] = []

  items.forEach(item => {
    response.push({
      quantity: item.quantity,
      amount: item.price,
      discount: item.discount,
      metadata: item.metadata,
    })
  })

  return response
}
